import API from '../services/api'

const authProvider = {
  // called when the user attempts to log in
  login: async ({ email, password }: any) => {
    try {
      const response = await API.post('/sessions', { email, password })

      const token = response.data?.token?.token

      if (!token) Promise.reject()

      localStorage.setItem('@Connectm:token', token)

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  },
  // called when the user clicks on the logout button
  logout: async () => {
    try {
      await API.delete('/sessions')

      localStorage.removeItem('@Connectm:token')

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  },
  // called when the API returns an error
  checkError: () => Promise.resolve(),
  // called when the user navigates to a new location, to check for authentication
  checkAuth: () => {
    return localStorage.getItem('@Connectm:token') ? Promise.resolve() : Promise.reject()
  },
  // called when the user navigates to a new location, to check for permissions / roles
  getPermissions: () => Promise.resolve(),
}

export default authProvider
